import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  return <section className="py-[50px] md:py-[80px] px-6 bg-brand-black relative" data-id="element-131">
      <div className="max-w-[900px] mx-auto" data-id="element-132">
        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-133">
          {/* Left Image */}
          <FadeIn className="order-2 md:order-1" data-id="element-134">
            <div className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-135">
              <img src="https://images.unsplash.com/photo-1447005497901-b3e9ee359928?w=800&q=80" alt="Familia reunida en momento emotivo" className="w-full h-auto object-cover grayscale contrast-110 opacity-85 hover:opacity-100 transition-opacity duration-500" data-id="element-136" />
            </div>
          </FadeIn>

          {/* Right Text */}
          <FadeIn delay={0.2} className="order-1 md:order-2" data-id="element-137">
            <div className="space-y-6 text-[20px] text-brand-lightGray" data-id="element-138">
              <p className="text-white font-semibold" data-id="element-139">Nadie quiere pensarlo.</p>
              <p data-id="element-140">Pero la realidad es esta:</p>
              <p className="text-white font-bold text-2xl border-l-4 border-brand-gold pl-6 py-2 my-6 bg-white/5 rounded-r-lg" data-id="element-141">
                Un funeral promedio cuesta entre $9,000 y $12,000 dólares.
              </p>
              <p data-id="element-142">¿Tienes ese dinero guardado?</p>
              <p data-id="element-143">¿Lo tiene tu familia?</p>

              <div className="pt-4 space-y-4" data-id="element-144">
                <p data-id="element-145">
                  Cada día, familias enteras se endeudan para darle a su ser
                  querido un funeral digno.
                </p>
                <p className="text-white/80 italic" data-id="element-146">
                  Venden sus cosas. Piden préstamos. Se pelean entre hermanos.
                </p>
                <p data-id="element-147">Y todo porque alguien no pudo planificarlo a tiempo.</p>
              </div>

              <p className="text-2xl text-white font-serif font-bold pt-6 text-brand-gold" data-id="element-148">
                No dejes que eso le pase a los tuyos.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}